import { makeStyles } from "@mui/styles"

const styles = makeStyles(() => ({
  root: {
    marginTop: '2rem',
    '& > p > span': {
      fontWeight: 600,
    },
  },
}))

export default styles
